import React from 'react'

import Layout from '../layouts/en'
import SEO from '../components/seo'

import Bubble from '../components/Bubble'
import Testimonial from '../components/Testimonial'

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="Research" />

    <div
      className="bg-center bg-cover py-12 md:bg-center-x-40p lg:bg-center"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-research.jpg)` }}
      id="leading-research-institute"
    >
      <div className="container" style={{ minHeight: 500 + 'px' }} data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200}>
        <Bubble className="w-full md:w-2/3 lg:w-1/2"
          title="Leading Research Institute"
          subtitle=""
        >
          <div className="text-justify">
            <p className="mb-4">IFT’s faculty helps advance knowledge and practice in various relevant areas of major concern to industry and policymakers, from research helping Macao optimise its tourism capacity to effectively managing the challenges of human resources. The Institute is committed to conducting research that is significant on a global scale and communicates new knowledge to the community.</p>
            <p className="mb-4">The Institute conducts advanced and high-quality research by collaborating and working together with renowned partner universities across the world through various joint research projects and knowledge sharing activities.</p>
            <p>IFT believes firmly in international engagement which ranges from collaboration between individual academics to multidimensional cooperations among institutions. The aspiration of each research partnership is to achieve excellence and to make the greatest possible difference across the globe.</p>
          </div>
        </Bubble>
      </div>
    </div>

    <div className="py-8 md:py-12" id="international-conferences">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down" data-aos-delay={850}>International Conferences</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/3 flex">
            <div className="inset-0" data-aos="fade-right">
              <img src="/AnnualReport2017-2018/images/research/4.1.2.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full lg:w-2/3 flex mt-4 lg:mt-0" data-aos="fade-left">
            <div className="text-left mx-auto text-sm md:text-base pl-0 lg:pl-8 font-normal text-justify">
              <p className="mb-4">As an important member in tourism and hospitality related research, IFT frequently send representatives to international conferences, and organise international conferences in Macao, with the aim to offer a platform for industries elites and leading researchers to exchange knowledge and insights.</p>
              <p>From 12 to 14 December 2017, IFT coorganised the “Beyond the Waves: the 4<sup>th</sup> International Conference on Events” (ICE2017) with the Rosen College of Hospitality Management at the University of Central Florida, USA and Bournemouth University, United Kingdom in Orlando, Florida. The conference attracted 65 delegates from 13 countries and regions. World-renowned scholars included Prof. Abraham Pizam, Prof. Fevzi Okumus, Prof. Donald Getz, Prof. Rhodri Thomas, Prof. Judith Mair and Prof. Alan Fyall participated in the conference and shared their perceptions. The five-member delegation was led by Director of ITRC, Prof. Leonardo Dioko and ICE2017 Organization Committee Member and Lecturer Ubaldino Couto, and colleagues from the faculty, Dr. Laurie Baker-Malungu, Assistant Prof. Dr. Choi Suh Hee and Prof. Sherry Tan Xiu Chang.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="policy-research">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">Policy Research</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/2 flex" data-aos="fade-right">
            <div className="text-left mx-auto text-sm md:text-base lg:pl-8 font-normal text-justify">
              <p className="mb-4">IFT Tourism Research Centre (ITRC) aims to garner and disseminate knowledge about topics relevant to tourism and hospitality in Macao and across the world. Acting as a consultant to various government departments and a public policy think-tank, ITRC often collaborates with research partners and think-tanks abroad to make its researches more internationalised.</p>
              <p className="mb-4">ITRC compiles several tourism-related indicators, including the Macao Tourism Satisfaction Index. The Centre also regularly releases findings of the Macao Visitor Profile Survey, which delivers valuable market insights to managers in the tourism industry.</p>
              <p>Human resources, particularly in tourism and hospitality industry, is also one of the ITRC’s research focuses. The Macao Human Resource Monitoring Survey is a long-term project setting out to measure the attitudes, opinions and job satisfaction levels of workers in hospitality, gaming and tourism industries.</p>
            </div>
          </div>
          <div className="w-full lg:w-1/2 mt-8 lg:mt-0">
            <div className="lg:pl-8">
              <div data-aos="zoom-out" data-aos-delay={150}>
                <Testimonial
                  title="Among the topics of our research published in 2017/18 were:"
                  color="orange"
                >
                  <p>Macao Tourism Carrying Capacity</p>
                  <p>Macao Tourist Satisfaction Index</p>
                  <p>Visitor Profile Survey</p>
                  <p>Macao Human Resource Monitoring Surve</p>
                </Testimonial>
              </div>

              <div data-aos="zoom-out" data-aos-delay={300}>
                <Testimonial
                  title="In 2017/18 IFT served as consultant to the:"
                  color="blue"
                  className="mt-8"
                >
                  Macau Hotel Association
                </Testimonial>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
